"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Ac = function Ac(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "36",
    height: "29",
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.30347 25.5455L3.47311 27.3991C4.01963 27.831 4.69991 28.0584 5.39632 28.0419C6.09265 28.0578 6.77273 27.8305 7.31954 27.3991L9.73382 25.3366C10.2806 24.9052 10.9607 24.6778 11.657 24.6937C12.3535 24.6772 13.0337 24.9046 13.5803 25.3366L15.9963 27.3991C16.5508 27.816 17.2258 28.0415 17.9195 28.0415C18.6133 28.0415 19.2883 27.816 19.8428 27.3991L22.257 25.3366C22.8117 24.9192 23.487 24.6935 24.1811 24.6935C24.8753 24.6935 25.5506 24.9192 26.1053 25.3366L28.5213 27.3991C29.076 27.8165 29.7513 28.0422 30.4454 28.0422C31.1396 28.0422 31.8149 27.8165 32.3695 27.3991L34.782 25.3366M27.032 18.3098L28.5195 19.5866C29.0742 20.004 29.7495 20.2297 30.4436 20.2297C31.1378 20.2297 31.8131 20.004 32.3678 19.5866L34.782 17.5241M1.30347 17.733L3.47311 19.5866C4.01963 20.0185 4.69991 20.2459 5.39632 20.2294C6.09265 20.2453 6.77273 20.018 7.31954 19.5866L8.77132 18.3455M14.5749 3.48837L17.9231 5.72051L21.2713 3.48837M17.9231 19.1134V1.25623M14.5749 16.8812L17.9231 14.6491L21.2713 16.8812M24.6195 6.83658L22.3874 10.1848L24.6195 13.533M8.99454 10.1848H26.8517M11.2267 6.83658L13.4588 10.1848L11.2267 13.533",
    stroke: fill,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
Ac.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Ac.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Ac;